import 'Styles/messages.scss';

import React from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';

import messagesSelector from 'Selectors/messagesSelector';
import { pathToMessages, pathToMessagesFolder } from 'Utils/nav/NavHelpers';
import { trackGAEvent, trackPageView, onPageView } from 'Actions/adsActions';
import { fetchMessages } from 'Actions/MessagesviewActions';
import { resetSelectedItem } from 'Actions/MetaActions';

import AdComponent from 'Components/ads/AdComponent';
import UserIcon from 'Components/common/UserIconComponent';
import SvgIcon from 'Components/svg/SvgIcon';
import LoaderCss from 'Components/common/LoaderCssComponent';

import decode from 'Utils/entities';
import rawToReact from 'Utils/bbcode/RawToReact';
import Date from 'Components/common/dateComponent';

class MessageViewComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			headerHeight: 0
		};
	}

	componentWillMount() {
		// Grab the page we are coming from to send the user back
		this.previousPage = parseInt( this.props.location.query.frompage ) || 1;
		this.props.dispatch( replace( this.props.location.pathname ) );
	}

	componentDidMount() {
		this.props.dispatch( resetSelectedItem() );
		this.props.dispatch( fetchMessages( {
			pmroute: 'pm',
			id: this.props.params.messageId
		} ) );
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.messagesview.loaded !== this.props.messagesview.loaded ||
			nextProps.messagesview.isFetching !== this.props.messagesview.isFetching ||
			nextProps.messagesview.result.pmfolders.length !== this.props.messagesview.result.pmfolders.length ||
			nextProps.messagesview.result.pms.length !== this.props.messagesview.result.pms.length ||
			nextProps.params.messageId !== this.props.params.messageId ||
			nextState.headerHeight !== this.state.headerHeight
		);
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.params.messageId !== this.props.params.messageId ) {
			this.props.dispatch( fetchMessages( {
				pmroute: pmroute,
				id: nextProps.params.messageId
			} ) );
		} else if( nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	componentDidUpdate() {
		this.repositionScroll();
	}

	goToFolder( folderId ) {
		if( isFinite( parseInt( folderId ) ) ) {
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent(false, 'backToMessagesFolder', 'uiAction', 'tap') );

			let folderLocation = { pathname: pathToMessagesFolder( folderId ) };
			folderLocation.query = Object.assign( { msgid: this.props.params.messageId }, ( this.previousPage > 1 ? { page: this.previousPage } : {} ) );

			this.props.dispatch( push( folderLocation ) );

		} else {
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent(false, 'backToMsgFolderList', 'uiAction', 'tap') );
			this.props.dispatch( push( pathToMessages() ) );
		}
	}

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();

			if( headerDim.height && headerDim.height !== this.state.headerHeight ) {
				this.setState( { headerHeight: headerDim.height + this.getHeaderHeight() } );
			}
		}
	};

	getHeaderHeight = () => {
		let header = document.getElementById( 'header' );
		return header ? header.getBoundingClientRect().height : 0;
	};

	_getHeather() {
		const { entities, loaded, isFetching } = this.props.messagesview;
		let folderId = loaded && !isFetching ? entities.pms[ this.props.params.messageId ].folder : null,
			folderName = folderId ? entities.pmfolders[ folderId ].name : null,
			linkBack = folderName ?
				<span className="loadMore" onClick={ () => this.goToFolder( folderId ) } >Return to <strong>{ folderName }</strong></span> :
				<span className="loadMore" onClick={ () => this.goToFolder( false ) } >Go back to Messages</span>;

		return (
			<header className="thread topLink" ref={ ( h ) => this.header = h }>
				{ linkBack }
			</header>
		);
	}

	render() {
		const { entities: { pms, users }, loaded, isFetching } = this.props.messagesview;

		if( !loaded || isFetching ) {
			return <div className='messagesRoot messagesContainer'>{ this._getHeather() }<LoaderCss style={ { marginTop: this.state.headerHeight + 'px' } } /></div>;
		}

		let pm = pms[ this.props.params.messageId ],
			msgText = rawToReact( ( pm.message ), this.props.messagesview.entities, true ),
			userFrom = <UserIcon user={ users[ pm.fromUser ] } />,
			bottomAdUnit = <AdComponent adType="2" adName="Bottom_Content_Rectangle" />,
			usersTo_list = pm.toUser.map( ( k ) => {
				let onlineStatus = users[ k ].online === true ? <span className="status online"><SvgIcon size="12px" icon="account_circle" /></span> : null;
				return (
					<li className="user-info" key={`toUser_${k}`}>
						<div className="username">{ users[ k ].userName } {onlineStatus}</div>
					</li>
				);
			} ),
			usersTo = pm.toUser.length ? <div className="usersTo postFooter"><ul>{ usersTo_list }</ul></div> : null;

		return (
			<div className="messagesRoot messagesContainer nolinks">
				{ this._getHeather() }
				<ul style={ { marginTop: this.state.headerHeight + 'px' } } >
					<li className="post thread pmpreview">
						<div className="left">
							{ userFrom }
						</div>
						<div className="right">
							<div className="stats single-right">
								<Date timestamp={ pm.dateline } icon={ true } />
							</div>
							<div className="title">{ decode( pm.title ) }</div>
							<div className="body" id={ `pm_message_${pm.id}` }>
								{ msgText }
							</div>
							{ usersTo }
						</div>
					</li>
				</ul>
				{bottomAdUnit}
			</div>
		);
	}
}

export default connect( messagesSelector )( MessageViewComponent );


// WEBPACK FOOTER //
// ./src/components/messages/MessageViewComponent.js